import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { AppService } from '../../services/app.service';


@Component({
  selector: 'app-header',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  assetsUrl: string = '';

  constructor(appService: AppService) {
    this.assetsUrl = appService.ENV.ASSETS_BASE_URL;
  }

  // ngOnInit(): void {
  //   // You can add any initialization logic here

  // }
}

